export const API_SIGN_IN = "auth/login/";
export const QMS_LINK_LIST = "auth/token/screen/";
export const WEB_SOCKET_DOMAIN = "wss://api.emedhub.in/ws/";
export const QMS_TOKEN_WEBSOCKET = "token-screen/";
export const SEARCH_MOBILE = 'fo/qr/patient/search/'

